import { isAfter, subHours } from 'date-fns'

import { Role } from '@/types/auth'
import { Log, LogPermission } from '@/types/logs'

const isLogCreatedWithinLast24Hours = (createdAt: string): boolean => {
    const inputDate = new Date(createdAt)
    const now = new Date()
    const twentyFourHoursAgo = subHours(now, 24)

    return isAfter(inputDate, twentyFourHoursAgo)
}

export const checkIsLogAvailableToBeDuplicate = (role: Role, log: Log, logPermission: LogPermission[]): boolean => {
    if (role === Role.PerformanceManager) {
        return true
    }

    if (role === Role.MileageClerk && logPermission.includes('Duplicate')) {
        return true
    }

    return isLogCreatedWithinLast24Hours(log.timestamp) && log.codingPeriodInfo.permissions.includes('Duplicate')
}
